import {useDispatch} from 'react-redux'
import DarkDownloadIcon from '../../../../media/felsv/dark_download_icon.svg'
import {ModalBase} from '../../../../components/Modals/ModalBase'
import {gu_cu_Clear} from '../../../../actions/gestion-usuario/creacion-usuario/creacionUsuario.actions'
import {bindActionCreators} from 'redux'
import {actionsGUCreacionUsuario} from '../../../../actions/action-creators'

const ModalUserCreated = (props: any) => {
  const dispatch = useDispatch()
  const actions = bindActionCreators(actionsGUCreacionUsuario, dispatch)

  const aceptar = () => dispatch(gu_cu_Clear())

  return (
    <ModalBase>
      <div className='modal-card'>
        <div className='modal-content'>
          <div className='w-layout-hflex'>
            <h3 className='card-title l'>¡Usuario creado exitosamente!</h3>
          </div>
          <div className='form-separator'></div>
          <div className='w-layout-hflex button-actions'>
            <button className='m button transparent w-inline-block' onClick={() => actions.generatePDFInfo()}>
              <img src={DarkDownloadIcon} loading='lazy' alt='' />
              <div>Descargar PDF</div>
            </button>
            <button className='m button w-inline-block' onClick={aceptar}>
              <div>Aceptar</div>
            </button>
          </div>
        </div>
      </div>
    </ModalBase>
  )
}

export default ModalUserCreated
